require('@rails/ujs').start()
require('turbolinks').start()
require('jquery') // for cocoon
require('@nathanvda/cocoon') // for nested forms

import axios from 'axios'
window.axios = axios

import '@popperjs/core'
import * as bootstrap from 'bootstrap'
import { Modal } from 'bootstrap'
import lightbox from 'lightbox2'
import { patchBootstrap } from './shared_helpers'
window.Modal = Modal
window.bootstrap = bootstrap

import '../stylesheets/application'

import { buildAbstractPreview } from '../util/abstract_preview'
window.buildAbstractPreview = buildAbstractPreview

// Configure Lightbox2 options (optional)
lightbox.option({
  resizeDuration: 200,
  wrapAround: true,
  disableScrolling: true, // Good practice to prevent background scroll
})

document.addEventListener('DOMContentLoaded', function (event) {
  patchBootstrap()
  // Lightbox2 initializes automatically based on data attributes
  // No explicit initialization needed here unless re-binding after dynamic content load without Turbolinks
})

document.addEventListener('turbolinks:load', function (event) {
  // Lightbox2 might need re-initialization or checks after Turbolinks load
  // For now, rely on its standard behavior with data attributes.
  // If issues arise, we might need explicit re-binding logic here.
})
